if (!window.Eurus.loadedScript.has('share-cart.js')) {
  window.Eurus.loadedScript.add('share-cart.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartShare', {
        openShareCart: false,
        cartShareUrl: "",
        shared: false,
        copySuccess: false,
        shareLinkBrokenMessage: 'This cart link is incomplete. Please ask for a new share link, or book the workshop again from the workshop page.',
        shareAddFailedMessage: 'We could not add these items to your cart. Please try the link again.',
        normalizeLineProperties(properties) {
          if (!properties) return null;
          const obj = {};
          const add = (key, value) => {
            if (key == null || key === '' || value == null || value === '') return;
            obj[String(key)] = String(value);
          };
          if (Array.isArray(properties)) {
            properties.forEach((entry) => {
              if (!entry) return;
              add(entry[0] != null ? entry[0] : entry.name, entry[1] != null ? entry[1] : entry.value);
            });
          } else if (typeof properties === 'object') {
            Object.keys(properties).forEach((key) => add(key, properties[key]));
          } else {
            return null;
          }
          return Object.keys(obj).length ? obj : null;
        },
        shareSkipKeys: {
          _capacity_remaining: true,
          _capacity_source: true,
          _event_status: true
        },
        pickShareProperties(properties) {
          const normalized = this.normalizeLineProperties(properties);
          if (!normalized) return null;
          const picked = {};
          Object.keys(normalized).forEach((key) => {
            if (this.shareSkipKeys[key]) return;
            picked[key] = normalized[key];
          });
          return Object.keys(picked).length ? picked : null;
        },
        encodeItemProperties(properties) {
          if (!properties || !Object.keys(properties).length) return '';
          try {
            const json = JSON.stringify(properties);
            return btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
          } catch (_) {
            return '';
          }
        },
        decodeItemProperties(encoded) {
          if (!encoded) return null;
          const tryParse = (value) => {
            try {
              const parsed = JSON.parse(value);
              if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
              return parsed;
            } catch (_) {
              return null;
            }
          };
          try {
            let b64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
            while (b64.length % 4) b64 += '=';
            const parsed = tryParse(decodeURIComponent(escape(atob(b64))));
            if (parsed) return parsed;
          } catch (_) {}
          try {
            return tryParse(encoded) || tryParse(decodeURIComponent(encoded));
          } catch (_) {
            return null;
          }
        },
        buildShareUrl(items) {
          const cartParams = items.map((item) => {
            const picked = this.pickShareProperties(item.properties);
            const encoded = this.encodeItemProperties(picked);
            if (picked && !encoded) return '';
            let part = `id:${item.variant_id},q:${item.quantity}`;
            if (encoded) part += `,p:${encoded}`;
            return part;
          }).filter(Boolean).join('&') + '&share_cart:true';
          return `${window.location.origin}?${cartParams}`;
        },
        generateUrl() {
          fetch(Shopify.routes.root + 'cart.js', {
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          })
          .then(response => response.json())
          .then(response => {
            this.cartShareUrl = this.buildShareUrl(response.items.slice().reverse());
          });
        },
        copyURL() {
          const cartShareInput = document.getElementById(`x-share-cart-field`);
          if (cartShareInput) {
            navigator.clipboard.writeText(cartShareInput.value).then(
              () => {
                this.copySuccess = true;
                setTimeout(() => {
                  this.copySuccess = false;
                }, 2000);
              },
              () => {
                alert('Copy fail');
              }
            );
          }
        },
        handleShareCart() {
          const queryString = window.location.search;
          if (!queryString.includes("share_cart:true")) return;
          let propsCorrupt = false;
          const items = queryString
            .substring(1)
            .split('&')
            .reduce((listItem, param) => {
                if (param.startsWith('id:')) {
                  const match = param.match(/^id:(\d+),q:(\d+)(?:,p:(.*))?$/);
                  if (!match) return listItem;
                  const item = { id: parseInt(match[1], 10), quantity: parseInt(match[2], 10) };
                  if (match[3]) {
                    const properties = this.normalizeLineProperties(this.decodeItemProperties(match[3]));
                    if (!properties) {
                      propsCorrupt = true;
                      return listItem;
                    }
                    item.properties = properties;
                  }
                  listItem.push(item);
                }
                return listItem;
            }, []);
          if (propsCorrupt) {
            this.shared = true;
            window.alert(this.shareLinkBrokenMessage);
            return;
          }
          if (items.length > 0) {
            this.addCartItems(items);
          } else {
            this.shared = true;
          }
        },
        addCartItems(items) {
          const formData = {
            'items': items,
            'sections': Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id)
          }
          
          fetch(Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(formData)
          }).then(response => response.json())
            .then(response => {
              if (response.status == '422' || response.status === 422) {
                this.shared = true;
                window.alert(response.description || this.shareAddFailedMessage);
                return;
              }
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xMiniCart').openCart();
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
              this.shared = true;
            })
            .catch(() => {
              this.shared = true;
              window.alert(this.shareAddFailedMessage);
            });
        }
      });
    });
  });
}